import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';


const PreguntasFrecuentes = () => {
  
  return (
    <motion.div
    initial={{opacity: .6, scale: .7}}
    whileInView={{ opacity: 1, scale: 1, delay: 0.3 }}>
      <H2>Hacemos envíos a toda la república mexicana</H2>
    </motion.div>
    
  );
};
const H2 = styled.h2 `
  text-align: center;
  margin: auto auto 30px auto;
  border-bottom: 2px solid #000;
  width: 90%;
  max-width: 800px;
`
export default PreguntasFrecuentes;